import styled from 'styled-components';

const Col = styled.div`
  width: 100%;
  padding: 0 ${(props) => props.theme.spacing.columnGutter};
`;

export default Col;
